var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toasts",style:({ zIndex: !!_vm.toasts.length ? 50000 : -1 }),attrs:{"data-cy":"toast"}},_vm._l((_vm.toasts),function(toast){return _c('Toast',{key:toast.id,attrs:{"variant":toast.variant,"content":toast.content,"componentProps":toast.componentProps},on:{"close":function($event){return _vm.removeToast(toast)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }